import * as Yup from 'yup';

export const storyFormValidation = () => {
  return Yup.object().shape({
    message: Yup.string().required('required'),
  });
};
